import React, { useEffect, useState } from 'react';
import { useChatState, useChatDispatch } from '../context';
import { ScrollArea, Button, List, Box, Text } from '@mantine/core';
import { useDarkMode } from 'usehooks-ts';
import { useStyles } from './styles';

import { listConversations } from '../../../../graphql/queries';
import { generateClient } from 'aws-amplify/api';
import { Amplify } from 'aws-amplify';
import { getUserData } from '../../../../config/userSession';
export const ChatSidebar = ({ onSidebarClose }) => {
  const client = generateClient();

  Amplify.configure({
    API: {
      GraphQL: {
        endpoint: process.env.REACT_APP_API_URI,
        region: process.env.REACT_APP_AWS_REGION,
        defaultAuthMode: 'apiKey',
        apiKey: process.env.REACT_APP_APPSYNC_API_KEY
      }
    }
  });

  const dispatch = useChatDispatch();
  const { classes, cx } = useStyles();

  const { selectedChat, sentNewMessage, deletedConversation } = useChatState();

  const [loading, setLoading] = useState(false);

  const [isHovered, setIsHovered] = useState(false);

  const [conversations, setConversations] = useState([]);

  function capitalizeFirstLetter(string) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  }
  const { email } = getUserData();

  const capitalizedUserId = capitalizeFirstLetter(email);

  const getAllListConversation = async () => {
    setLoading(true);

    const variables = {
      filter: {
        userId: { eq: capitalizedUserId }
      }
    };

    const data = await client.graphql({
      query: listConversations,
      variables
    });

    if (data?.data) {
      setLoading(false);
    }
    const sortedConversations = data.data.listConversations.items.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    setConversations(sortedConversations);
  };

  useEffect(() => {
    if (capitalizedUserId !== null) {
      getAllListConversation();
    }
  }, [
    capitalizedUserId,
    sentNewMessage,
    deletedConversation,
    selectedChat?.id
  ]);

  // useEffect(() => {
  //   if (sentNewMessage) {
  //     dispatch({ type: "SET_SELECTED_CHAT", payload: conversations[conversations?.length - 1] });
  //   }
  // }, [sentNewMessage, conversations]);
  const { isDarkMode } = useDarkMode();
  return (
    <ScrollArea
      style={{
        height: '100%',
        backgroundColor: !isDarkMode ? '#fff' : '#FFFFFF',
        color: !isDarkMode ? '#000000' : '#000000',
        borderLeft: '1px solid #ccc' // Add this line
      }}
    >
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '1rem',
          marginBottom: '1rem'
        }}
      >
        <Button
          onClick={() => dispatch({ type: 'SET_SELECTED_CHAT', payload: null })}
          style={{
            width: '80%',
            background: !isDarkMode
              ? '#1E293B'
              : 'linear-gradient(339.49deg, rgb(6, 185, 185) 9.01%, rgb(0, 225, 225) 98.62%)',
            color: !isDarkMode ? '#FFFFFF' : '#FFFFFF'
          }}
        >
          New Chat
        </Button>
      </Box>

      {loading ? (
        <Text align="center">Loading...</Text>
      ) : conversations.length > 0 ? (
        <List style={{ padding: '0 1rem' }}>
          {conversations.map((chat) => {
            const isActive = selectedChat?.id === chat.id;

            let formattedTitle = chat?.title;

            if (chat?.title?.startsWith('Conversation at ')) {
              const titleParts = chat.title.split('at ');
              const rawDate = titleParts?.[1]?.trim();
              const parsedDate = new Date(rawDate);

              if (!isNaN(parsedDate.getTime())) {
                // Check if date is valid
                formattedTitle = `Conversation at ${parsedDate.toLocaleString(
                  'en-US',
                  {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }
                )}`;
              }
            }
            return (
              <List.Item
                key={chat.id}
                onClick={() => {
                  dispatch({ type: 'SET_SELECTED_CHAT', payload: chat });
                  onSidebarClose();
                }}
                className={cx(
                  classes.chatItem,
                  isDarkMode ? classes.dark : classes.light,
                  { active: isActive }
                )}
              >
                {formattedTitle}
              </List.Item>
            );
          })}
        </List>
      ) : (
        <Box style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Text>No conversations found.</Text>
          <Text size="sm" color="dimmed">
            Start a new chat to begin.
          </Text>
        </Box>
      )}
    </ScrollArea>
  );
};
